<template>
    <div class="container-fluid w-100 h-100" style="overflow-x: hidden">
        <navbar :title="$t('menu.invoicing')" class="mb-1"/>

        <ul
            class="nav nav-tabs routa-tabs"
            role="tablist"
        >
          <li class="nav-item">
              <button
                  class="routa-tab"
                  :class="{ active: tabIndex === 0 }"
                  :style="linkTabClass(0)"
                  @click="tabIndex = 0"
              >
                  {{ $t('daily_summary.invoice_acceptance') }}
              </button>
          </li>
          <li class="nav-item">
              <button
                  class="routa-tab"
                  :class="{ active: tabIndex === 1 }"
                  :style="linkTabClass(1)"
                  @click="tabIndex = 1"
              >
                  {{ $t('daily_summary.invoices') }}
              </button>
          </li>
            <li class="nav-item">
                <button
                    class="routa-tab"
                    :class="{ active: tabIndex === 2 }"
                    :style="linkTabClass(1)"
                    @click="tabIndex = 2"
                >
                    {{ $t('invoice_history.not_invoiced') }}
                </button>
            </li>
        </ul>
        <div class="tab-content routa-tab-content">
            <div v-show="tabIndex === 0" class="tab-pane fade show active"  style="min-height: 85vh">
              <div class="col-12 px-2 d-flex justify-content-end">
                  <div class="form-check form-switch">
                      <input
                          class="form-check-input"
                          type="checkbox"
                          id="ownContracts"
                          v-model="ownContracts"
                      >
                      <label class="form-check-label" for="ownContracts">
                          {{ $t('contracts.only_user_owned_contracts') }}
                      </label>
                  </div>
              </div>

              <div class="col-sm-12 nopads my-2">
                  <div v-if="!loading && results.length < 1"  class="col-12 text-center" style="padding-top: 20vh; color: #bcbcbc; font-size: 2em; font-weight: 300">{{ $t('common.no_results')}}</div>
                  <invoicing-list
                      :results="results"
                      :invoice-state-options="invoiceStateOptions"
                      :user="user"
                      :close-all-rows="closeAllRows"
                      @set-collapsed-state-back="closeAllRows = false"
                      @update-summaries="fetchInvoiceDrafts"
                      @accept-invoicing="acceptInvoicing"
                      @show-order="showOrder"
                      @show-trip-order="showTripOrder"
                      @show-invoice-histories="showInvoiceHistories"
                      @show-contract-details="showContractDetails"
                      @show-trip-details="showTripDetails"
                      @show-trip-deliveries="showTripDeliveries"
                  />

                  <base-modal
                    v-if="showHistories"
                    size="lg"
                    hide-header
                    hide-footer
                    prevent-close
                  >
                    <invoice-histories
                      v-if="showHistories && invoiceHistoryRow"
                      :summary-item="invoiceHistoryRow"
                      @close="showHistories = false; invoiceHistoryRow = null"
                    />
                  </base-modal>

                  <base-modal
                    v-if="showRowDetails"
                    size="lg"
                    hide-header
                    hide-footer
                    prevent-close
                  >
                    <contract-trip-details
                      v-if="tripDetailsRow && showRowDetails"
                      :order-item="order"
                      :summary-item="tripDetailsRow"
                      :trip-table="trips"
                      @close="showRowDetails = false"
                    />
                  </base-modal>

                  <base-modal
                    v-if="showDeliveries"
                    size="lg"
                    hide-header
                    hide-footer
                    prevent-close
                  >
                    <contract-trip-deliveries
                      v-if="tripDetailsRow && showDeliveries"
                      :summary-item="tripDetailsRow"
                      @close="showDeliveries = false"
                    />
                  </base-modal>

                  <base-modal
                    v-if="showContract"
                    size="lg"
                    hide-header
                    hide-footer
                  >
                    <contract-editor
                      v-if="showContract"
                      v-model="contract"
                      :active-order-editor="activeOrderEditor"
                      :contract-trip-list="true"
                      :user="user"
                      :show-title="false"
                      @close="showContract = false"
                    />
                  </base-modal>

                <base-modal
                  v-if="showOrderDetails"
                  size="lg"
                  hide-header
                  hide-footer
                >
                  <order-editor
                    v-if="showOrderDetails"
                    :order="order"
                    :user="user"
                    :show-title="false"
                    @close="closeOrder"
                    @close-and-update="closeOrderAndUpdate"
                  />
                </base-modal>

                <base-modal
                  v-if="showAcceptModal"
                  size="md"
                  hide-header
                  hide-footer
                  prevent-close
                >
                  <div class="p-3">
                    <h2 class="editor-header">{{ $t('daily_summary.accept_invoicing') }}</h2>
                    <p class="text-muted small p-0">{{ $t('daily_summary.accept_description') }}</p>
                    <div v-if="displayOrders?.length > 0">
                      <h6><b>{{ $t('daily_summary.order_close_title') }}</b></h6>
                      <div>
                        <div
                          v-for="item in displayOrders"
                          :key="item.order.id"
                          class="mt-2"
                        >
                          <span>
                            <b>{{ item.order.id }} - {{ item.order.task_type?.name }} {{ item.order.task_type?.company?.name ? "(" + item.order.task_type.company.name + ")" : "" }}</b>
                          </span>
                        </div>
                      </div>
                      <br>
                      <h6 v-if="tieraApiKeyAllowed"><b>{{ $t('daily_summary.send_to_tiera') }}</b></h6>
                      <div v-if="tieraApiKeyAllowed" class="form-check form-switch">
                        <input
                          class="form-check-input pe-3"
                          type="checkbox"
                          id="sendToTiera"
                          v-model="sendToTiera"
                        >
                        <label class="form-check-label ms-2" for="sendToTiera">
                            {{ $t('daily_summary.send_to_tiera_description') }}
                        </label>
                      </div>
                    </div>
                    <div class="d-flex justify-content-end mt-3">
                      <button class="btn btn-secondary me-2" @click="cancelAccept">
                        {{ $t('common.cancel') }}
                      </button>
                      <button
                        class="btn btn-success"
                        @click="confirmAccept"
                      >
                        {{ $t('work_permission.accept') }}
                      </button>
                    </div>
                  </div>
                </base-modal>
              <div
                v-if="loading"
                id="loader"
                class="spinner"
              />
              </div>
            </div>
            <div v-show="tabIndex === 1" class="tab-pane fade show active" style="min-height: 85vh">
                <invoice-history :user="user" :is-observer="isObserver" />
            </div>
            <div v-show="tabIndex ===2" class="tab-pane fade show active" style="min-height: 85vh">
                <not-invoiced/>
            </div>
        </div>
    </div>
</template>


<script>
import {workManagementHelper} from '../mixins/WorkManagementMixin'
import {restApi} from '../mixins/RestApiMixin'
import {timeUtils} from '@/components/mixins/TimeUtils'
import {invoiceStateHelper, invoiceStates} from "@/components/invoice/InvoiceMixin";
import {userHelper} from "@/components/mixins/UserMixin";
import InvoicingList from "@/components/invoice/InvoicingList.vue";
import ContractTripDeliveries from "@/components/tripsummary/ContractTripDeliveries.vue";
import ContractTripDetails from "@/components/tripsummary/ContractTripDetails.vue";
import OrderEditor from "@/components/order/OrderEditor.vue";
import ContractEditor from "@/components/contract/ContractEditor.vue";
import InvoiceHistories from "@/components/invoice/InvoiceHistories.vue";
import InvoiceHistory from "@/components/invoice/InvoiceHistory.vue";
import BaseModal from "@/components/BaseModal.vue";
import {inject} from "vue";
import Navbar from "@/components/utils/Navbar.vue";
import NotInvoiced from "./NotInvoiced.vue";

export default {
    name: 'Invoicing',
    components: {
        NotInvoiced,
        Navbar,
        BaseModal,
        InvoiceHistories,
        InvoiceHistory,
        ContractEditor, OrderEditor,
        ContractTripDetails, ContractTripDeliveries, InvoicingList
    },
    mixins: [workManagementHelper, restApi, timeUtils, invoiceStateHelper, invoiceStates, userHelper],
    props: {
        user: {
            type: Object,
            default: null
        },
        isObserver: {
            type: Boolean,
            default: false
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            tabIndex: 0,
            results: [],
            showContract: false,
            tripDetailsRow: null,
            invoiceHistoryRow: null,
            showHistories: false,
            showRowDetails: false,
            showDeliveries: false,
            showOrderDetails: false,
            activeOrderEditor: false,
            skiWorkDetailsRow: null,
            showSkiWorkDetails: false,
            order: null,
            contract: null,
            ownContracts: true,
            closeAllRows: false,
            trips: [],
            loading: false,
            lastSearchedParams: null,
            showAcceptModal: false,
            pendingInvoiceData: null,
            displayOrders: [],
            sendToTiera: false,
            tieraApiKeyAllowed: false
        }
    },
    computed: {
        invoiceStateOptions() {
            let invoiceStates = this.getInvoiceStates();
            return [...invoiceStates]
        }
    },
    watch: {
        ownContracts() {
            this.fetchInvoiceDrafts()
            this.closeAllRows = true
        }
    },
    mounted: function () {
        this.fetchInvoiceDrafts()
        this.checkTieraApiKeyAccess()
    },
    methods: {
        fetchInvoiceDrafts: function (params) {
            this.loading = true
            params = {}
            params.own = this.ownContracts
            this.lastSearchedParams = params
            this.restFetchParams(this.invoiceDraftUrl, this.lastSearchedParams, this.handleSummariesResponse)
        },

        handleSummariesResponse: function (response) {
            this.loading = false
            if (response && response.data) {
                this.results = response.data
            }
        },

        showTripDetails: function (selectedRow) {
            this.showTripOrder(selectedRow, false);
            this.tripDetailsRow = selectedRow;
            this.showRowDetails = true;
        },
        showTripDeliveries: function (selectedRow){
            this.tripDetailsRow = selectedRow
            this.showDeliveries = true
        },
        showInvoiceHistories(selectedRow) {
            this.invoiceHistoryRow = selectedRow
            this.showHistories = true
        },
        showContractDetails: function (selectedRow){
            this.tripDetailsRow = selectedRow
            let params = {}
            params.id = selectedRow.contract_id ? selectedRow.contract_id : null
            this.fetchContracts(params)
        },

        fetchOrders: function (params, showDetailsEditor) {
            this.handleOrders(params, showDetailsEditor);
        },

        handleOrders: function(params, showDetailsEditor) {
            this.loading = true;
            this.restFetch(this.orderUrl + "/" + params.id, (response) => {
                let fetchedOrder = response ? response.data : {};
                this.order = this.createEditorOrder(fetchedOrder);
                this.loading = false;
                if (showDetailsEditor) {
                    this.showOrderDetails = true;
                }
            }, this.orderFail);
        },

        fetchContracts: function(params) {
            this.loading = true
            this.restFetchParams(this.contractUrl, params, this.handleContracts, this.notAuthorized)
        },
        handleContracts: function (response) {
            let fetchedContract = response ? response.data[0] : {}
            this.loading = false
            if (fetchedContract && fetchedContract.is_contract_party) {
                this.contract = this.jsonToItem(fetchedContract)
                this.showContract = true
            }
        },

        notAuthorized: function () {
            this.loading = false
            this.showAlert(this.$t('daily_summary.contract_access_error'))
        },

        acceptInvoicing(item) {
            this.pendingInvoiceData = item
            this.displayOrders = item.orders_to_close && item.orders_to_close.length > 0 && item.invoice_rows
                ? item.invoice_rows
                    .flatMap(row => row.items || [])
                    .filter(i => item.orders_to_close.includes(i.order?.id))
                : []
            this.sendToTiera = false
            this.showAcceptModal = true
        },

        confirmAccept() {
            if (!this.hasContractSystem(this.user)) {
                this.showAcceptModal = false
                this.pendingInvoiceData = null
                this.displayOrders = []
                this.showAlert(this.$t('invoice_history.invoicing_integration_required'))
                return
            }
            const orderIds = this.pendingInvoiceData.orders_to_close || []
            const sendToTiera = this.sendToTiera
            const { id, created, paid, status, status_date, total_sum, contract, invoice_rows, attachment_ids } = this.pendingInvoiceData

            const invoiceDTO = {
                id,
                created,
                paid,
                status,
                status_date,
                total_sum,
                contract,
                invoice_rows: invoice_rows.map(row => ({
                    id: row.id ?? null,
                    invoice_id: id,
                    items: row.items ?? []
                })),
                attachment_ids: attachment_ids ?? []
            }

            this.loading = true
            this.showAcceptModal = false

            this.restUpdate(
                this.invoiceApprovalUrl,
                invoiceDTO,
                (response) => this.handleApprovalSuccess(response, orderIds, sendToTiera),
                this.acceptInvoicingFail
            )
        },

        handleApprovalSuccess(response, orderIds, sendToTiera) {
            this.downloadInvoiceJson(response)

            if (orderIds && orderIds.length > 0 && sendToTiera) {
                this.restUpdate(this.orderTieraSendUrl,
                    { orders: orderIds },
                    () => this.handleOrdersSendSuccess(orderIds),
                    this.acceptInvoicingFail
                )
            } else if (orderIds && orderIds.length > 0) {
                this.handleOrdersSendSuccess(orderIds)
            } else {
                this.finalizeInvoicing()
            }
        },

        handleOrdersSendSuccess(orderIds) {
            this.restUpdate(
                this.orderCloseUrl,
                { orders: orderIds },
                this.handleOrdersCloseSuccess,
                this.acceptInvoicingFail
            )
        },

        handleOrdersCloseSuccess() {
            this.finalizeInvoicing()
        },

        finalizeInvoicing() {
            this.loading = false
            this.fetchInvoiceDrafts()
            this.showAlert(this.$t('daily_summary.invoice_accepting_succeeded'), 'success')
        },

        cancelAccept() {
            this.showAcceptModal = false
            this.pendingInvoiceData = null
            this.displayOrders = []
        },

        downloadInvoiceJson(response) {
            let blob = new Blob([response], { type: 'application/json' });
            let url = URL.createObjectURL(blob);
            let pom = document.createElement('a');
            pom.href = url;
            pom.setAttribute('download', 'invoicing.json');
            pom.click();
        },

        acceptInvoicingFail() {
            this.loading = false;
            this.showAlert(this.$t('daily_summary.invoice_accepting_failed'));
        },

        closeOrder: function() {
            this.showOrderDetails = false
            this.order = null
        },

        closeOrderAndUpdate() {
            this.closeOrder()
            this.fetchInvoiceDrafts();
        },

        showOrder(order) {
            if (order && order.id) {
                let params = {}
                params.id = order.id ? order.id : null
                this.fetchOrders(params, true)
            }
        },

        showTripOrder: function (selectedRow, showDetailsEditor = true){
            this.tripDetailsRow = selectedRow
            let params = {}
            params.id = selectedRow.order.id ? selectedRow.order.id : null
            this.fetchOrders(params, showDetailsEditor)
        },

        checkTieraApiKeyAccess() {
            // TODO maybe put apikey types to some config
            this.restFetchParams(this.apiUrl, {type: 9}, this.handleTieraApiKeySuccess, this.handleTieraApiKeyFail)
        },

        handleTieraApiKeySuccess() {
            this.tieraApiKeyAllowed = true
        },

        handleTieraApiKeyFail() {
            this.tieraApiKeyAllowed = false
        },

        linkTabClass(index) {
            if (this.tabIndex === index) {
                return ['tab-title', 'tab-title-active']
            } else {
                return ['tab-title']
            }
        },
    }
}
</script>
